import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getAllAdmins } from '../../middleware/backend_hepler';
import { FaEdit } from 'react-icons/fa';
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Loader from '../../components/Loader';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Paginations from '../../components/Paginations';


const EmployeeList = () => {
  const [employeeLists, setEmployeeLists] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [messageDisplayed, setMessageDisplayed] = React.useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterStatus, setFilterStatus] = useState("All");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [employeesPerPage, setEmployeesPerPage] = useState(10);

  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    if (location.state?.successMessage && !messageDisplayed) {
      console.log(location.state.successMessage);
      toast.success(location.state.successMessage);
      setMessageDisplayed(true);

      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state, navigate, messageDisplayed]);
  
  useEffect(() => {
    const fetchEmployeeLists = async () => {
      try {
        const response = await getAllAdmins();
        setEmployeeLists(response);
        setLoading(false);
      } catch (error) {
        setError('Error fetching business loans.');
        setLoading(false);
      }
    };
    fetchEmployeeLists();
  }, []);

  const handleStaffButtonClick = () => {
    navigate("/create-employee");
  };

  const handleEdit = (id) => {
    navigate(`/edit-employee/${id}`);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  };

  const isWithinDateRange = (dateString) => {
    if (!startDate && !endDate) return true;

    const loanDate = new Date(dateString);
    const start = startDate ? new Date(startDate) : null;
    const end = endDate ? new Date(endDate) : null;

    if (start && end && start.toDateString() === end.toDateString()) {
      return loanDate.toDateString() === start.toDateString();
    }

    if (start && end) {
      return loanDate >= start && loanDate <= end;
    }
    if (start) {
      return loanDate >= start;
    }
    if (end) {
      return loanDate <= end;
    }

    return true;
  };

  const employeeLoans = employeeLists
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    .filter((loan) => {
      const searchQueryLower = searchQuery.toLowerCase();

      const matchesSearch =
        loan.name?.toLowerCase().includes(searchQueryLower) ||
        loan.id?.toString().toLowerCase().includes(searchQueryLower) ||
        loan.mobile?.toString().toLowerCase().includes(searchQueryLower);

      const matchesStatus =
        filterStatus === "All" || loan.status === filterStatus;

      const matchesDate = isWithinDateRange(loan.created_at);

      const isEmployee = loan.role === "employee";

      return isEmployee && matchesSearch && matchesStatus && matchesDate;
    });

  const indexOfLastEmployee = currentPage * employeesPerPage;
  const indexOfFirstEmployee = indexOfLastEmployee - employeesPerPage;
  const currentEmployees = employeeLoans.slice(indexOfFirstEmployee, indexOfLastEmployee);

  if (loading) {
    return <Loader/>;
  }
  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="home-loan-screen">
      <h4 className="agent-title">Employee</h4>
      <div className="agent">
        <div className="search-bar">
          <input
            type="text"
            placeholder="Id, Name, MobileNo"
            value={searchQuery}
            onChange={handleSearchChange}
          />
          <FontAwesomeIcon icon={faSearch} className="search-icon" />
        </div>
        <button className="agent-button" onClick={handleStaffButtonClick}>
          <span className="plus-icon">+</span> Add Employee
        </button>
      </div>
      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>Employee ID</th>
              <th>Name</th>
              <th>Email</th>
              <th>Mobile Number</th>
              <th>Role</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentEmployees.map((loan, index) => (
               <tr
                key={index}
                onClick={() => handleEdit(loan.id)}
                style={{ cursor: "pointer" }}
             >
                <td>{loan.id}</td>
                <td>{loan.name}</td>
                <td>{loan.email}</td>
                <td>{loan.mobile}</td>
                <td>{loan.role}</td>
                <td style={{
                  color: loan.status === 'Active' ? 'var(--status-green)' : 
                         loan.status === 'Inactive' ? 'var(--status-red)' : 
                         'black' 
                }}> {loan.status} </td>
                <td>
                  <FaEdit
                    className="edit-icon"
                    onClick={() => handleEdit(loan.id)}
                    style={{ cursor: 'pointer' }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <Paginations
          perPageData={employeesPerPage}
          data={employeeLoans}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          isShowingPageLength={true}
          paginationDiv="pagination-container"
          paginationClass="pagination"
        />
      </div>
    </div>
  );
};

export default EmployeeList;
